/**
 * This enum handle theme rendering for smart component.
 * This value is not related to app theme for decaplouging app with smart component theme
 */
export enum SmartComponentTheme {
    BIGSTUDIO = 1,
    DIGITAL_PLACE = 2
}